export default "__VITE_ASSET__B714NoNW__"